import store from '@/store/index.js'
import { localeCompareAlphanumeric } from '@/utils/base'

export function diameterGroupSorter (diameterGroupA, diameterGroupB) {
  let result = (diameterGroupA.lowerBound ?? 0) - (diameterGroupB.lowerBound ?? 0)
  if (result === 0) {
    result = (diameterGroupA.upperBound ?? Number.MAX_SAFE_INTEGER) - (diameterGroupB.upperBound ?? Number.MAX_SAFE_INTEGER)
  }
  if (result === 0) {
    result = localeCompareAlphanumeric(diameterGroupA?.label ?? '', diameterGroupB?.label ?? '')
  }
  return result
}

export function diameterGroupSorterByLabel (diameterGroupLabelA, diameterGroupLabelB) {
  const dgA = store.getters['account-scaling/accountDiameterGroups']
    .find(dg => dg.label === diameterGroupLabelA)
  const dgB = store.getters['account-scaling/accountDiameterGroups']
    .find(dg => dg.label === diameterGroupLabelB)
  if (!dgA || !dgB) return localeCompareAlphanumeric(diameterGroupLabelA ?? '', diameterGroupLabelB ?? '')
  return diameterGroupSorter(dgA, dgB)
}

export function getDiameterGroupTooltip (rateSheetLine, accountId, diameterGroups) {
  function matchesById (dg) {
    return dg.diameterGroupId === (rateSheetLine.diameterGroupId ?? rateSheetLine.diameterGroup?.diameterGroupId)
  }
  function matchesByLabel (dg) {
    return dg.label === rateSheetLine.diameterGroup
  }

  if (!diameterGroups && accountId !== store.getters['account-scaling/accountIdOfDiameterGroups']) return undefined
  const diameterGroup = (diameterGroups ?? store.getters['account-scaling/accountDiameterGroups'])
    .find(dg => matchesById(dg) || matchesByLabel(dg))
  if (!diameterGroup) return undefined
  return `${diameterGroup.lowerBound}" \u2014 ${diameterGroup.upperBound}"`
}
